import React, { useState } from 'react';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { Membership, MembershipItem } from '@spike/membership-model';
import { MembershipItemsTable } from 'components/Memberships/Add/Steps/Items/Table/MembershipItemsTable';
import Button from 'components/UI/V2/Button/Button';

interface MembershipItemsStepProps {
    membership: Membership;
    onNext: (items: MembershipItem[]) => void;
    marketplaceID: number;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        stepDescription: {
            color: '#7A7A7A',
            fontSize: 15,
            lineHeight: 1.4,
            fontWeight: 400,
            marginTop: -28,
            marginBottom: 10,

            [theme.breakpoints.up('md')]: {
                marginTop: -20
            }
        },
        submitButton: {
            marginTop: 8,

            [theme.breakpoints.up('md')]: {
                alignSelf: 'flex-start'
            }
        }
    })
);

export const MembershipItemsStep: React.FC<MembershipItemsStepProps> = props => {
    const classes = useStyles();

    const [items, setItems] = React.useState<MembershipItem[]>(props.membership.membershipItems);
    const [loading, setLoading] = useState(false);

    const isValid = React.useMemo(() => {
        const emptyItems = items.filter(item => !item.itemID);

        return items.length > 0 && emptyItems.length === 0;
    }, [items]);

    const handleSave = async () => {
        if (loading) return;
        setLoading(true);
        try {
            await props.onNext(items);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Typography className={classes.stepDescription}>
                Add the services, add-ons, and products included in the membership.
            </Typography>

            <MembershipItemsTable
                items={items}
                onChange={setItems}
                marketplaceID={props.marketplaceID}
            />

            <Button
                label="Save"
                size="large"
                disabled={!isValid || loading}
                className={classes.submitButton}
                onClick={handleSave}
            />
        </>
    );
};
